import AddPhysicianForm from 'components/addPhysician/AddPhysicianForm';
import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchPhysicianDetails } from '../../../redux/slices/physicianSlice';

export default function AddPhysician() {
  const dispatch = useDispatch();
  const {physicianId=''} = useParams();

  useEffect(()=>{
    if(physicianId){
      dispatch(fetchPhysicianDetails(physicianId));
    }
  },[physicianId]);
  return (
    <CommonLayout>
      <AddPhysicianForm/>
    </CommonLayout>
  );
}